import { ChatIcon, HomeIcon, UserIcon } from '@sharedCR/coreDesignSystem/icons';

import { COLOR_PALETTE } from 'constants/ui';

/** The three top-level objects creatable from the "+" flow. */
export const CREATE_OBJECT = {
  CONTACT: 'contact',
  LEAD: 'lead',
  LOAN: 'loan',
};

/** The two views inside the create bottom sheet. */
export const CREATE_STEP = {
  PICKER: 'picker',
  FORK: 'fork',
};

/**
 * Object-picker rows, in display order. `id` maps to a CREATE_OBJECT value; the
 * component filters this list by the user's per-object create permission.
 * `iconColor` tints the per-object icon tile (decorative — no semantic token).
 */
export const CREATE_OBJECT_OPTIONS = [
  {
    id: CREATE_OBJECT.CONTACT,
    title: 'Contact',
    subtitle: 'A person — borrower, agent, partner',
    icon: ChatIcon,
    iconColor: COLOR_PALETTE.CYAN[6],
  },
  {
    id: CREATE_OBJECT.LEAD,
    title: 'Lead',
    subtitle: 'A prospect to work & convert',
    icon: UserIcon,
    iconColor: COLOR_PALETTE.PURPLE[6],
  },
  {
    id: CREATE_OBJECT.LOAN,
    title: 'Loan',
    subtitle: 'A new loan file / application',
    icon: HomeIcon,
    iconColor: COLOR_PALETTE.BLUE[7],
  },
];

/** Display label per object id, used in the fork header ("Create new <label>"). */
export const CREATE_OBJECT_LABEL = {
  [CREATE_OBJECT.CONTACT]: 'Contact',
  [CREATE_OBJECT.LEAD]: 'Lead',
  [CREATE_OBJECT.LOAN]: 'Loan',
};

/** Eyebrow above the two method cards in the fork step. */
export const FORK_PROMPT = 'How do you want to start?';

/** Copy + icon tint for the "Enter details" method card (today's manual form path). */
export const ENTER_DETAILS_COPY = {
  title: 'Enter details',
  subtitle: 'Fill out the form yourself — the standard flow you use today.',
};

export const ENTER_DETAILS_ICON_COLOR = COLOR_PALETTE.GRAY[7];

/**
 * Copy for the "Start with photos" method card — opens the multi-document
 * capture session (DEV-4252). Upload + extraction reuse the DEV-4250 path; the
 * draft-create that gives the batch a target lands downstream (DEV-4251).
 */
export const START_WITH_PHOTOS_COPY = {
  title: 'Start with photos',
};

export const PHOTOS_ICON_COLOR = COLOR_PALETTE.BLUE[7];

/** Label for the dedicated primary CTA below the method cards. */
export const CONTINUE_WITH_PHOTOS_LABEL = 'Continue with photos';

/**
 * Per-object photo-path copy + the document-type chips shown on the "Start with
 * photos" card. Mirrors the approved mockup's object-specific guidance.
 */
export const PHOTOS_DETAILS_BY_OBJECT = {
  [CREATE_OBJECT.CONTACT]: {
    subtitle: 'Snap a business card or ID. We create the contact and fill it in.',
    chips: ['Business card', 'ID'],
  },
  [CREATE_OBJECT.LEAD]: {
    subtitle: 'Snap an open-house sheet or card. We create the lead and fill it in.',
    chips: ['Open-house sheet', 'Card'],
  },
  [CREATE_OBJECT.LOAN]: {
    subtitle:
      "Snap the borrower's documents. We create the draft and fill it in for you to review.",
    chips: ['ID', 'Paystub', 'W-2', 'Purchase contract'],
  },
};
